// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import Partners from './components/Partners';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ContactPage from './pages/ContactPage';
import EngineeringPage from './pages/EngineeringPage';
import CustomerSuccessPage from './pages/CustomerSuccessPage';
import BusinessDevelopmentPage from './pages/BusinessDevelopmentPage';
import DesignUXPage from './pages/DesignUXPage';

// 👈 IMPORT THE NEW PAGE HERE
import CareersPage from './pages/CareersPage.jsx'; 
import './index.css';

const AdminRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://api.efatechsolutions.com/admin';
  }, []);
  return <div>Redirecting to Admin Panel...</div>;
};

function AppContent() {
  const location = useLocation();
  // Check if we are on the contact page only
  const isSpecialPage = location.pathname === '/contact';

  return (
    <div className="App bg-white text-gray-900 font-sans antialiased min-h-screen flex flex-col">
      {/* Show Header on all pages except contact */}
      {!isSpecialPage && <Header />}
      
      <main className="flex-1">
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <About />
              <Projects />
              <Partners />
              <Testimonials />
              <Contact />
            </>
          } />
          {/* ADD THE NEW ROUTE HERE 👇 */}
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminRedirect />} />
          <Route path="/careers/engineering" element={<EngineeringPage />} />
          <Route path="/careers/customer-success" element={<CustomerSuccessPage />} />
          <Route path="/careers/business-development" element={<BusinessDevelopmentPage />} />
          <Route path="/careers/design-ux" element={<DesignUXPage />} />

        </Routes>
      </main>
      
      {/* Show Footer on home page and careers, hide on contact */}
      {location.pathname === '/' || location.pathname === '/careers' ? <Footer /> : null}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;